import {
  createGoldBotResourceReader,
  isPlainObject,
} from "./goldBotResource";

export const getGoldBotEvents = createGoldBotResourceReader({
  path: "/events",
  label: "events",
  isValidPayload: (payload) =>
    isPlainObject(payload) &&
    Array.isArray(payload.events) &&
    typeof payload.available === "boolean",
});
